export default __webpack_public_path__ + "9fd5e48de32545132d14d8fdc918c5b5.svg";